import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import ReactMapGL, {
  FlyToInterpolator,
  Source,
  Layer,
  NavigationControl,
} from "react-map-gl";
import Markers from "./Markers";
import Geocoder from "react-map-gl-geocoder";
import "react-map-gl-geocoder/dist/mapbox-gl-geocoder.css";
// 3rd-party easing functions
import * as d3 from "d3-ease";
import mapboxgl from "mapbox-gl";
import { Editor, DrawPolygonMode, EditingMode } from "react-map-gl-draw";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import "mapbox-gl/dist/mapbox-gl.css";
import "./Map.scss";
import Header from "../UI/Header/Header";
import SpinnerHandler from "../../hoc/SpinnerHandler/SpinnerHandler";
import Footer from "../UI/Footer/Footer";
import MapData from "./MapData";
import AUX from "../../hoc/AU-X/AU-X";
import useWindowDimensions from "../../hooks/WindowDimensions";
import { Popup } from "react-map-gl";
import { getFeatureStyle, getEditHandleStyle } from "./style";
import ControlPanel from "./control-panel";
import Icon from "@mdi/react";
import { useDispatch, useSelector } from "react-redux";
import ShowError from "../UI/ShowError/ShowError";
import { logout } from "../../store";
import moment from "moment-jalaali";
import { mdiCheckOutline } from "@mdi/js";
import Accordion from "../Accordion";
import StackUI from "./StackUI";
import ChartView from "./ChartView";
import { RotateLeft } from "@mui/icons-material";
import { BottomSheet } from "react-spring-bottom-sheet";
import { Helmet } from "react-helmet";
import * as turf from "@turf/turf";
import DataListUi from "./DataListUi";

// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass =require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;

// Set mapbox token here
const MAPBOX_TOKEN =
  "pk.eyJ1IjoibWFydGlucm9vc3RhIiwiYSI6ImNranBmY3ZraTAzeG4ycnFodHU0eXRtdTIifQ.pQkgKigEngOD5sIMFJ40gg";

// setRTLTextPlugin(
//   // find out the latest version at https://www.npmjs.com/package/@mapbox/mapbox-gl-rtl-text
//   'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
//   null,
//   // lazy: only load when the map first encounters Hebrew or Arabic text
//   true
// );

const Map = (props) => {
  const { width } = useWindowDimensions();
  const { showOnMap, children } = props;
  const [viewport, setViewport] = useState({
    latitude: 37.1,
    longitude: 46.8,
    zoom: 6.8,
  });
  const dispatch = useDispatch();
  const editorRef = useRef(null);
  const [mode, setMode] = useState();
  const [cursorType, setCursorType] = useState();
  const [polygon, setPolygon] = useState();
  const [standardPolygon, setStandardPolygon] = useState();
  const [selectedFeatureIndex, setSelectedFeatureIndex] = useState();
  const [Stack, setStack] = useState([]);
  const [geojson, setGeojson] = useState();
  const [mouseCordinates, setMouseCordinates] = useState([51.389, 35.6892]);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [showSuccesMessage, setShowSuccesMessage] = useState(false);
  const [displayMarker, setdisplayMarker] = useState({
    hydrometricSelect: false,
    synopticSelect: false,
    weatherSelect: false,
    damsSelect: false,
  });
  const token = useSelector((state) => state.auth.Token);
  const [selectMarker, setSelectedMarker] = useState(null);
  const [uploadedFile, setUploadedFile] = useState();
  const [selectDate, setSelectDate] = useState();
  const mapRef = useRef(null);
  const [stackProduct, setStackProduct] = useState([]);
  const [drawToolsShow, setDrawToolsShow] = useState(true);
  const [buttonReset, setButtonReset] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadErrorMessage, setUploadErrorMessage] = useState(false);
  const [deletShapeMessage, setDeletShapeMessage] = useState(false);
  const [showProduct, setShowProduct] = useState(false);
  const [dateList, setDateList] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [polygonReset, setPolygonReset] = useState(false);
  const [startDate, setStartDate] = useState(
    moment("1380/01/01", "jYYYY/jM/jD")
  );
  const [EndDate, setEndDate] = useState(moment().locale("fa"), "jYYYY/jM/jD");
  const [openBottomSheet, setOpenBottomSheet] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState();
  const [dateError, setDateError] = useState(false);
  const [downloadLink, setDownloadLink] = useState({
    tif: "",
    png: "",
    xmin: "",
    ymin: "",
    xmax: "",
    ymax: "",
  });
  const [chartData, setChartData] = useState();
  const [currentPolygonPoint, setCurrentPolygonPoint] = useState();
  const [distance, setDistance] = useState("");
  const acceptInput = (type) => {
    if (type !== "polygon") {
      setButtonReset(true);
      setDrawToolsShow(false);
    }
    setShowSuccesMessage(true);
    setTimeout(() => setShowSuccesMessage(false), 3000);
    setMode(null);
    setShowProduct(true);
    setLoading(false);
  };

  const rejectInput = () => {
    setShowErrorMessage(true);
    setTimeout(() => setShowErrorMessage(false), 3000);
    setLoading(false);
    setUploadedFile(null);
  };
  const uploadHttpPolygon = (plygon) => {
    setLoading(true);
    fetch(
      `http://213.233.177.17:8022/polygon_upload/?file_format=polygon&polygon=${plygon}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        const detail = data.detail;
        if (
          data &&
          (detail === "Invalid Token" ||
            detail === "Access token expired" ||
            detail === "Given token not valid for any token type")
        ) {
          dispatch(logout());
        } else {
          console.log(data);
          setStandardPolygon(data.polygon);
          acceptInput("polygon");
          setPolygonReset(true);
        }
      })
      .catch((err) => {
        rejectInput();
      });
  };

  const uploadHttpFiles = () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("file", uploadedFile.data);
    fetch(
      `http://213.233.177.17:8022/polygon_upload/?file_format=${uploadedFile.type}`,
      {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        const detail = data.detail;
        if (
          data &&
          (detail === "Invalid Token" ||
            detail === "Access token expired" ||
            detail === "Given token not valid for any token type")
        ) {
          dispatch(logout());
        } else {
          const fObj = {
            type: "Feature",
            properties: {},
            geometry: {
              coordinates: [JSON.parse(data.polygon_list)],
              type: "Polygon",
            },
          };
          console.log(data);
          setUploadedFile(null);
          setStandardPolygon(data.polygon);
          setPolygon(fObj);
          acceptInput("file");
        }
      })
      .catch((err) => rejectInput());
  };

  const handleSelectMarker = (item) => {
    setSelectedMarker(item);
  };
  const marker = useMemo(() => {
    const url = {
      Dams: "map/dams/",
      WeatherStation: "map/weather-stations/",
      Hydrometric: "map/hydrometric-stations/",
      Synoptic: "map/synoptic-stations/",
    };
    return (
      <>
        {displayMarker.hydrometricSelect && (
          <Markers
            color="red"
            handleSelectMarker={handleSelectMarker}
            link={url["Hydrometric"]}
          />
        )}
        {displayMarker.synopticSelect && (
          <Markers
            color="blue"
            handleSelectMarker={handleSelectMarker}
            link={url["Synoptic"]}
          />
        )}
        {displayMarker.weatherSelect && (
          <Markers
            color="yellow"
            handleSelectMarker={handleSelectMarker}
            link={url["WeatherStation"]}
          />
        )}
        {displayMarker.damsSelect && (
          <Markers
            color="green"
            handleSelectMarker={handleSelectMarker}
            link={url["Dams"]}
          />
        )}
      </>
    );
  }, [displayMarker]);

  const handleViewportChange = useCallback(
    (newViewport) => setViewport(newViewport),
    []
  );

  useEffect(() => {
    if (showOnMap) {
      if (showOnMap.onlyTravel) {
        setViewport((v) => ({
          ...v,
          longitude: showOnMap.long,
          latitude: showOnMap.lat,
          zoom: 14,
          transitionDuration: 5000,
          transitionInterpolator: new FlyToInterpolator(),
          transitionEasing: d3.easeCubic,
        }));

        return;
      }
      console.log(showOnMap.area);

      let zoom = 0;

      if (showOnMap.area < 3) {
        zoom = 17;
      } else if (showOnMap.area < 10) {
        zoom = 15;
      } else if (showOnMap.area < 50) {
        zoom = 14;
      } else if (showOnMap.area < 1000) {
        zoom = 13;
      } else {
        zoom = 11;
      }

      setViewport((v) => ({
        ...v,
        longitude: showOnMap.coordinates[0][0],
        latitude: showOnMap.coordinates[0][1],
        zoom: zoom,
        transitionDuration: 5000,
        transitionInterpolator: new FlyToInterpolator(),
        transitionEasing: d3.easeCubic,
      }));

      setGeojson({
        type: "FeatureCollection",
        features: [
          {
            type: "Feature",
            geometry: {
              type: "Polygon",
              coordinates: [showOnMap.coordinates],
            },
          },
        ],
      });
    }
  }, [showOnMap, setViewport, setGeojson]);

  const renderJson = useMemo(() => {
    if (geojson) {
      return (
        <Source id="my-data" type="geojson" data={geojson}>
          <Layer
            paint={{ "fill-color": "rgba(234, 85, 7, 0.5)" }}
            id="point"
            type="fill"
          />
        </Source>
      );
    } else return null;
  }, [geojson]);

  const renderMouse = useMemo(() => {
    if (currentPolygonPoint) {
      var from = turf.point(currentPolygonPoint);
      var to = turf.point([mouseCordinates[0], mouseCordinates[1]]);
      var distance = turf.distance(from, to);
      setDistance((distance * 1000).toFixed(2));
      // console.log("distance is: ", distance * 1000);
    }

    return (
      <div className="lngLat">
        <div className="center">
          <div>مختصات نقطه</div>
          <div>
            lat: <span>{mouseCordinates[1]}</span>, long:{" "}
            <span>{mouseCordinates[0]}</span>
          </div>
        </div>
      </div>
    );
  }, [mouseCordinates, currentPolygonPoint]);

  // const changeMapLnaguage = () => {
  //   const map = mapRef.current.getMap();
  // map.addSource('mapbox-dem', {
  //   "type": "raster-dem",
  //   "url": "mapbox://mapbox.mapbox-terrain-dem-v1",
  // });
  // map.setTerrain({ "source": "mapbox-dem" });
  // }

  const layers = useMemo(() => {
    const the = Stack.map((e) => MapData[e]);

    return the.map((item) => (
      <AUX key={item.name}>
        <Source {...item.source} />
        <Layer {...item.layer} />
      </AUX>
    ));
  }, [Stack]);

  const isStackItem = useCallback((stack, item) => {
    let the = -1;

    stack.forEach((element, index) => {
      if (element === item) {
        the = index;
      }
    });
    return the;
  }, []);

  const handleStack = useCallback(
    (item) => {
      setStack((pre) => {
        const FStack = [...pre];

        if (pre.length > 0) {
          const the = isStackItem(pre, item);
          if (the > -1) {
            FStack.splice(the, 1);

            return FStack;
          }
        }

        FStack.push(item);
        return FStack;
      });
    },
    [setStack, isStackItem]
  );

  const handleProductStack = (e) => {
    setSelectDate(null);
    setOpenBottomSheet(false);
    setSelectedProduct(e);
    setDownloadLink({ ...downloadLink, png: "" });
    const fetchData = () => {
      setLoading(true);
      fetch(
        `http://213.233.177.17:8022/get_date/?product=${e.tag}&polygon=${standardPolygon}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => res.json())
        .then((data) => {
          const detail = data.detail;
          if (
            data &&
            (detail === "Invalid Token" ||
              detail === "Access token expired" ||
              detail === "Given token not valid for any token type")
          ) {
            dispatch(logout());
          } else {
            console.log(data);
            setDateList(data.date_list);
            setLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    };
    const fetchShowPolygon = () => {
      setLoading(true);
      fetch(
        `http://213.233.177.17:8022/map_upload/?product=${e.tag}&polygon=${standardPolygon}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          const detail = data.detail;
          if (
            data &&
            (detail === "Invalid Token" ||
              detail === "Access token expired" ||
              detail === "Given token not valid for any token type")
          ) {
            dispatch(logout());
          } else {
            console.log(data);
            setDownloadLink(data);
            setLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    };

    const temp = [...stackProduct];
    if (!temp.find((id) => id === e.id)) {
      if (e.tag !== "BAS" && e.tag !== "dem") {
        fetchData();
      } else {
        fetchShowPolygon();
      }

      temp.push(e.id);
      setStackProduct([e.id]);
    } else {
      const data = temp.filter((id) => id !== e.id);
      setStackProduct(data);
    }
  };

  const handleAcceptPolygon = () => {
    if (!polygonReset) {
      let polygonBodyType = "POLYGON((";
      const coordinates = polygon.geometry.coordinates[0];
      for (let i = 0; i < coordinates.length; i++) {
        polygonBodyType =
          polygonBodyType + coordinates[i][0] + " " + coordinates[i][1] + ",";
      }
      polygonBodyType =
        polygonBodyType.substring(0, polygonBodyType.length - 1) + "))";
      uploadHttpPolygon(polygonBodyType, "polygon");
    } else {
      setPolygon(null);
      setChartData(null);
      editorRef.current.deleteFeatures(selectedFeatureIndex);
      setDrawToolsShow(true);
      setPolygonReset(false);
      setUploadedFile(null);
      setStackProduct([]);
      setShowProduct(false);
      setDownloadLink({ ...downloadLink, png: "" });
    }
  };

  const handleAccept = () => {
    if (!buttonReset) {
      if (uploadedFile) {
        uploadHttpFiles();
      } else {
        setUploadErrorMessage(true);
        setTimeout(() => setUploadErrorMessage(false), 4000);
      }
    } else {
      setPolygon(null);
      setChartData(null);
      editorRef.current.deleteFeatures(selectedFeatureIndex);
      setDrawToolsShow(true);
      setButtonReset(false);
      setUploadedFile(null);
      setStackProduct([]);
      setShowProduct(false);
      setDownloadLink({ ...downloadLink, png: "" });
    }
  };

  const deletMessage = () => {
    setDeletShapeMessage(true);
    setTimeout(() => setDeletShapeMessage(false), 3000);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const handleOpenModal = () => {
    setOpenModal(true);
  };

  useEffect(() => {
    const listener = (e) => {
      if (e.key === "Escape") {
        handleSelectMarker(null);
      }
    };
    window.addEventListener("keydown", listener);
    return () => window.addEventListener("click", listener);
  }, []);

  const _onSelect = (options) => {
    if (options) {
      setSelectedFeatureIndex(options.selectedFeatureIndex);
    }
  };

  const _onDelete = useCallback(() => {
    if (selectedFeatureIndex !== null && selectedFeatureIndex >= 0) {
      editorRef.current.deleteFeatures(selectedFeatureIndex);
      setPolygon(null);
      setShowProduct(false);
    } else {
      editorRef.current.deleteFeatures(
        editorRef.current.getFeatures().length - 1
      );
      setPolygon(null);
    }
  }, [selectedFeatureIndex]);

  const _onUpdate = ({ editType, editContext }) => {
    // console.log(editContext.position);
    if (editContext.position) {
      setCurrentPolygonPoint(editContext.position);
    }
    if (editType === "addFeature") {
      setDistance("");
      setCurrentPolygonPoint(null);
      setCursorType(false);
      setMode(new EditingMode());
    }
    if (editType) {
      getPolygon(editorRef.current.getFeatures());
    }
  };

  const getPolygon = (features) => {
    // console.log(features);
    if (selectedFeatureIndex) {
      setPolygon(features[selectedFeatureIndex]);
    } else {
      setPolygon(features[features.length - 1]);
    }
  };
  const _getCursor = useCallback(
    ({ isHovering, isDragging }) => {
      if (cursorType) {
        return "crosshair";
      }
      if (isDragging) {
        return "grabbing";
      } else {
        return "grab";
      }
    },
    [cursorType]
  );
  const handleEditingMode = () => {
    if (!cursorType) {
      if (!editorRef.current.getFeatures().length) {
        setCursorType(true);
        setMode(new DrawPolygonMode());
      } else if (editorRef.current.getFeatures().length) {
        deletMessage();
      }
    } else {
      setCursorType(false);
      setMode(null);
    }
  };

  const _drawTools = (
    <div className="mapboxgl-ctrl-top-left mapboxgl-ctrl-custom">
      <div className="mapboxgl-ctrl-group mapboxgl-ctrl">
        {!polygonReset && (
          <>
            <button
              className="mapbox-gl-draw_ctrl-draw-btn mapbox-gl-draw_polygon"
              title="Polygon tool (p)"
              onClick={handleEditingMode}
            />
            <button
              className="mapbox-gl-draw_ctrl-draw-btn mapbox-gl-draw_trash"
              title="Delete"
              onClick={_onDelete}
            />
          </>
        )}

        {polygon && (
          <button
            className="mapbox-gl-draw_ctrl-draw-btn"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            name="polygon"
            title="reset"
            onClick={handleAcceptPolygon}
          >
            {polygonReset ? (
              <RotateLeft />
            ) : (
              <Icon
                path={mdiCheckOutline}
                title="check polygon"
                size={0.6}
                rotate={0}
                color="#000"
              />
            )}
          </button>
        )}
      </div>
    </div>
  );

  const handleDate = useCallback(() => {
    if (startDate.format("YYYY-MM-DD") !== EndDate.format("YYYY-MM-DD")) {
      setLoading(true);
      const sm = moment(startDate).locale("fa").format("YYYY-MM-DD");
      const em = moment(EndDate).locale("fa").format("YYYY-MM-DD");
      fetch(
        `http://213.233.177.17:8022/time_series/?start_date=${sm}&end_date=${em}&polygon=${standardPolygon}`,
        {
          method: "GET",
          // body: body,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          const detail = data.detail;
          if (
            data &&
            (detail === "Invalid Token" ||
              detail === "Access token expired" ||
              detail === "Given token not valid for any token type")
          ) {
            dispatch(logout());
          } else if (data.type !== "invalid_request") {
            console.log(data);
            setLoading(false);
            const labelsChart = [];
            for (let index = 0; index < Object.keys(data).length; index++) {
              labelsChart.push(
                moment(Object.keys(data)[index]).format("jYYYY/jMM/jDD")
              );
            }
            const dataChart = Object.values(data);
            setChartData({
              data: {
                labels: labelsChart,
                datasets: [
                  {
                    label: "# of Votes",
                    data: dataChart,
                    borderColor: "rgba(54, 162, 235, 1)",
                    borderWidth: 2,
                  },
                ],
              },
              options: {
                maintainAspectRatio: false,
                responsive: true,
                animation: false,
                normalized: true,
                spanGaps: true,
                // showLine: false,
                datasets: {
                  line: {
                    pointRadius: 0, // disable for all `'line'` datasets
                  },
                },
                plugins: {
                  title: {
                    display: true,
                    text: "تبخیر و تعرق",
                    font: {
                      family: "IRANSansWeb",
                      size: 18,
                      lineHeight: 2,
                    },
                  },
                  legend: {
                    labels: {
                      // This more specific font property overrides the global property
                      font: {
                        size: 14,
                        family: "IRANSansWeb",
                      },
                    },
                    display: false,
                  },
                },
                scales: {
                  yAxes: {
                    title: {
                      display: true,
                      // text: 'yAxisTitle',
                      font: {
                        size: 15,
                        family: "IRANSansWeb",
                      },
                    },
                  },
                  xAxes: {
                    x: {
                      type: "time",
                      time: {
                        unit: "Month",
                      },
                    },
                    title: {
                      display: false,
                      text: "سال",
                      font: {
                        size: 15,
                        family: "IRANSansWeb",
                      },
                    },
                    ticks: {
                      maxTicksLimit: 12,
                    },
                  },
                },
              },
            });
          } else {
            setDateError(true);
            setTimeout(() => setDateError(false), 3000);
            setLoading(false);
            setChartData(null)
          }
        })
        .catch((err) => {
          setLoading(false);
          alert("Server Error");
        });
    } else {
      setDateError(true);
      setTimeout(() => setDateError(false), 3000);
      setChartData(null)

    }
  }, [standardPolygon, startDate, EndDate, dispatch, token]);

  const showUploadPolygon = useMemo(() => {
    return (
      !!polygon && (
        <>
          <Source
            id="maine"
            type="geojson"
            data={{
              type: "Feature",
              geometry: {
                type: "Polygon",
                // These coordinates outline Maine.
                coordinates: polygon.geometry.coordinates,
              },
            }}
          />
          <Layer
            id="maine"
            source="maine"
            type="fill"
            // source-layer="maine"
            layout={{}}
            paint={{
              "fill-color": "#0080ff", // blue color fill
              "fill-opacity": 0.5,
            }}
          />
          <Layer
            id="outline"
            layout={{}}
            source="maine"
            type="line"
            // source-layer="maine"
            paint={{
              "line-color": "#000",
              "line-width": 3,
            }}
          />
        </>
      )
    );
  }, [polygon]);

  const showPng = useMemo(() => {
    if (downloadLink && downloadLink.png.length > 0) {
      return (
        <>
          <Source
            id="image-source"
            type="image"
            url={"http://213.233.177.17:8022/" + downloadLink.png}
            coordinates={[
              [downloadLink.xmin, downloadLink.ymax],
              [downloadLink.xmax, downloadLink.ymax],
              [downloadLink.xmax, downloadLink.ymin],
              [downloadLink.xmin, downloadLink.ymin],
              // [45.0963, 37.7684],
              //   [45.0963, 37.5586],
              //   [45.7715, 37.5586],
              //   [45.7715, 37.7684],
            ]}
          />
          <Layer
            id="image-source"
            source="image-source"
            type="raster"
            paint={{ "raster-opacity": 0.85 }}
          />
        </>
      );
    } else {
      return null;
    }
  }, [downloadLink]);

  const download = (theLink, name) => {
    fetch(theLink, {
      method: "GET",
    })
      .then((response) => {
        response.arrayBuffer().then(function (buffer) {
          const url = window.URL.createObjectURL(
            new Blob([buffer, { type: "image/png" }])
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${name}`); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const downloadWithoutTime = useMemo(() => {
    return (
      <div className="button-download-without-time">
        <h3>دریافت فایل</h3>
        <div>
          <button
            onClick={() =>
              download(
                "http://213.233.177.17:8022/" + downloadLink.png,
                `${selectedProduct.tag}.png`
              )
            }
          >
            .png
          </button>
          <a
            className="download-link"
            href={"http://213.233.177.17:8022/" + downloadLink.tif}
          >
            <button>.tiff</button>
          </a>
        </div>
      </div>
    );
  }, [downloadLink, selectedProduct]);

  return (
    <SpinnerHandler isLoading={loading}>
      <Helmet>
        <title>نقشه</title>
      </Helmet>

      <Header
        UI={
          <StackUI
            polygon={polygon}
            deletMessage={deletMessage}
            handleAccept={handleAccept}
            buttonReset={buttonReset}
            showProduct={showProduct}
            handleProductStack={handleProductStack}
            stackProduct={stackProduct}
            setUploadedFile={setUploadedFile}
            uploadedFile={uploadedFile}
            handleOpenModal={handleOpenModal}
            handleStack={handleStack}
            isStackItem={isStackItem}
            Stack={Stack}
            setdisplayMarker={setdisplayMarker}
            displayMarker={displayMarker}
            setSelectedProduct={setSelectedProduct}
          />
        }
      />
      {showErrorMessage && <ShowError type="error">محدوده ثبت نشد</ShowError>}
      {showSuccesMessage && (
        <ShowError type="">محدوده با موفقیت ثبت شد</ShowError>
      )}
      {uploadErrorMessage && (
        <ShowError type="error">فایل خود را آپلود کنید</ShowError>
      )}
      {deletShapeMessage && (
        <ShowError type="error">شکل قبلی را حذف کنید</ShowError>
      )}
      <div className="mapWrap">
        {width < 450 && (
          <div
            style={{
              position: "absolute",
              top: 60,
              right: 60,
              zIndex: 3,
              width: 200,
            }}
          >
            <Accordion>
              {polygon && <ControlPanel polygon={polygon} />}
              {renderMouse}
            </Accordion>
          </div>
        )}
        <ChartView
          openModal={openModal}
          handleCloseModal={handleCloseModal}
          startDate={startDate}
          setStartDate={setStartDate}
          EndDate={EndDate}
          setEndDate={setEndDate}
          handleDate={handleDate}
          selectedProduct={selectedProduct}
          chartData={chartData}
          loading={loading}
          dateError={dateError}
        />
        {(stackProduct[0] === 1 || stackProduct[0] === 3) &&
          downloadWithoutTime}

        {!!stackProduct.length &&
          selectedProduct.tag !== "BAS" &&
          selectedProduct.tag !== "dem" &&
          width < 450 && (
            <button
              className="button-exist-date"
              onClick={() => setOpenBottomSheet(true)}
            >
              تاریخ های موجود
            </button>
          )}
        {!!stackProduct.length &&
          selectedProduct.tag !== "BAS" &&
          selectedProduct.tag !== "dem" &&
          width > 450 && (
            <DataListUi
              setLoading={setLoading}
              standardPolygon={standardPolygon}
              setDownloadLink={setDownloadLink}
              dateList={dateList}
              selectDate={selectDate}
              setSelectDate={setSelectDate}
              selectedProduct={selectedProduct}
              download={download}
              downloadLink={downloadLink}
            />
          )}
        {!!stackProduct.length &&
          selectedProduct.tag !== "BAS" &&
          selectedProduct.tag !== "dem" &&
          width < 450 && (
            <BottomSheet
              open={openBottomSheet}
              onDismiss={() => {
                setOpenBottomSheet(false);
              }}
            >
              <DataListUi
                setLoading={setLoading}
                standardPolygon={standardPolygon}
                setDownloadLink={setDownloadLink}
                dateList={dateList}
                selectDate={selectDate}
                setSelectDate={setSelectDate}
                selectedProduct={selectedProduct}
                download={download}
                downloadLink={downloadLink}
              />
            </BottomSheet>
          )}
        {width > 450 && (
          <StackUI
            polygon={polygon}
            deletMessage={deletMessage}
            handleAccept={handleAccept}
            buttonReset={buttonReset}
            showProduct={showProduct}
            handleProductStack={handleProductStack}
            stackProduct={stackProduct}
            setUploadedFile={setUploadedFile}
            uploadedFile={uploadedFile}
            handleOpenModal={handleOpenModal}
            handleStack={handleStack}
            isStackItem={isStackItem}
            Stack={Stack}
            setdisplayMarker={setdisplayMarker}
            displayMarker={displayMarker}
          />
        )}
        <ReactMapGL
          ref={mapRef}
          mapboxApiAccessToken={MAPBOX_TOKEN}
          {...viewport}
          width="100vw"
          getCursor={_getCursor}
          height={width < 450 ? "450px" : "610px"}
          onViewportChange={setViewport}
          // mapStyle={'mapbox://styles/martinroosta/cks7hh3uc15aj18p1j1wzdqe3'}
          mapStyle={
            "mapbox://styles/martinroosta/ckly0lfu06ujs17ptlwdfpcuo?optimize=true"
          }
          onMouseMove={(event) => {
            if (document.getElementById("a")) {
              document.getElementById("a").style.top = event.point[1] + "px";
              document.getElementById("a").style.left = event.point[0] + "px";
            }

            setMouseCordinates([
              event.lngLat[0].toFixed(4),
              event.lngLat[1].toFixed(4),
            ]);
          }}
        >
          <Editor
            style={{ width: "100%", height: "100%" }}
            ref={editorRef}
            mode={mode}
            featureStyle={getFeatureStyle}
            editHandleStyle={getEditHandleStyle}
            editHandleShape={"circle"}
            onSelect={_onSelect}
            onUpdate={_onUpdate}
            clickRadius={12}
          />
          {!drawToolsShow || (!uploadedFile && _drawTools)}
          <Geocoder
            mapRef={mapRef}
            onViewportChange={handleViewportChange}
            mapboxApiAccessToken={MAPBOX_TOKEN}
            position="top-right"
            placeholder="جستجو"
            language="fa"
            clearOnBlur={true}
          />
          {width >= 450 && <NavigationControl style={{ top: 10, left: 10 }} />}

          {showUploadPolygon}

          {showPng}

          {layers}

          {marker}

          {width >= 450 && renderMouse}

          {renderJson}

          {children}

          {width >= 450 && <ControlPanel polygon={polygon} />}

          {currentPolygonPoint && (
            <div
              id="a"
              style={{
                position: "absolute",
                zIndex: 5,
                backgroundColor: "rgba(255,255,255,0.5)",
                margin: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                padding: 20,
                borderRadius: 10,
                fontWeight: "bold",
              }}
            >
              <p>{distance}</p>
              <p>متر</p>
            </div>
          )}

          {selectMarker && (
            <Popup
              latitude={selectMarker.lat}
              longitude={selectMarker.lng}
              onClose={() => handleSelectMarker(null)}
            >
              <div className="popupContainer">
                <h3>{selectMarker.name}</h3>
              </div>
            </Popup>
          )}
        </ReactMapGL>
      </div>
      <Footer />
    </SpinnerHandler>
  );
};

export default Map;

// {
/* <Source id='map-source-1' type='vector' url={'mapbox://martinroosta.bw0yf5gv'} />
          <Layer
            id='overlay-1'
            source='map-source-1'
            type='heatmap'
            source-layer='village_pop95-12armk'
            // layout={{
            //   'line-join': 'round',
            //   'line-cap': 'round',
            // }}
            paint={{
              'heatmap-opacity': 0.7,
              'heatmap-radius': 5,
              // 'line-color': '#ff69b4',
              // 'line-width': 1,
            }}
          /> */
// }

// {
/* <Source id='map-source-4' type='vector' url={'mapbox://martinroosta.d374kkpq'} />
          <Layer
            id='overlay-2'
            source='map-source-4'
            // source='mapbox://martinroosta.6s67w0o0'
            type='fill'
            source-layer='subbasin-9nm7om'
            paint={{
              // 'fill-color': '#888',
              'fill-color': [
                'match',
                ['get', 'Basin_En'],
                ...createLayerColor(subbasin),
              ],
              'fill-opacity': 0.4,
              'fill-outline-color': '#333',
              // 'fill-antialias': true,
            }}
          /> */
// }

// {
/* <Source id='map-source-2' type='vector' url={'mapbox://martinroosta.6s67w0o0'} />
          <Layer
            id='overlay-2'
            source='map-source-2'
            // source='mapbox://martinroosta.6s67w0o0'
            type='fill'
            source-layer='mahdude-1n5oe8'
            paint={{
              // 'fill-color': '#888',
              'fill-color': [
                'match',
                ['get', 'Area_en'],
                ...createLayerColor(mahdude),
                // 'Black',
                // '#223b53',
                // 'Hispanic',
                // '#e55e5e',
                // 'Asian',
                // '#3bb2d0',
              ],
              'fill-opacity': 0.4,
              'fill-outline-color': '#333',
              // 'fill-antialias': true,
            }}
          /> */
// }

// {
/* <Source id='map-source-3' type='vector' url={'mapbox://martinroosta.0iie1w4t'} />
          <Layer
            id='overlay-3'
            source='map-source-3'
            type='line'
            source-layer='Aquifer-6qn8av'
            paint={{
              'line-blur': 1,
              'line-color': '#de5246',
              // 'fill-color': '#de5246',
              // 'fill-opacity': 0.5,
              // 'fill-outline-color': '#333',
            }}
          /> */
// }
